<div class="modal-header m-transparent">
  <button type="button" class="close mr-1" aria-label="Close" (click)="activeModal.dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <h1 class="app-title-midi">כדי להמשיך, נא לקרוא ולאשר את תנאי השימוש</h1>
  <div class="app-font-regular m-terms-use-text m-term-border">
    <ol>
      <li>הודעתם לנו, כי לצורך אישור ההלוואה וקבלת ההלוואה, הננו נדרשים להמציא לבנק פרטים שונים, הנוגעים לנו, למצבנו
        הכלכלי והאישי. פרטים אלה נדרשים לבנק כדי לבדוק את הבקשה להלוואה, ביצועה וניהולה וגם מאחר שהבנק מחוייב לשמור מידע
        ולהעבירו לרשויות שונות, בהתאם לדרישות חוקיות ורגולטוריות, כפי שיהיו מעת לעת. בעוד שאין עלינו חובה לפי חוק למסור
        לכם פרטים אלה, ומסירתם תלויה ברצוננו ובהסכמתנו, אנו מבינים שללא הסכמתנו למסירת פרטים אלה, לא יוכל הבנק לבחון את
        בקשתנו ולהעמיד לנו את ההלוואה ( אם תאושר ויתקיימו התנאים לביצועה).</li>
      <li>אנו מייפים את כוחכם לקבל מכל מקור שהוא, לרבות ממרשם האוכלוסין, כל מידע שיש בידיהם מכל מקור שהוא, ואשר יראה לכם
        דרוש לדיון בבקשה ו/או לצורך אימות הפרטים המפורטים בה. ידוע לנו ואנו מסכימים שהמקורות שמהם תקבלו מידע כזה יכולים
        לכלול כל בנק , חברה או מעביד; כל מאגרי המידע של הבנק. ידוע לנו, שאין ביכולת הבנק לאמת את הנתונים הנמסרים על ידי
        המקורות הללו, ואנו מוותרים אפוא על כל טענה ו/או תביעה כנגד הבנק בקשר לאי אימות הנתונים.</li>
      <li>במקרה בו הוצע על ידינו או נדרש על ידי הבנק צירוף ערבים או שעבוד נכסים להבטחת ההלוואה על ידי צדדים שלישים
        (ערבים ומשעבדים כאמור, יקראו להלן- "ערבים") להלוואה, יהיה הבנק רשאי להעביר את המידע שקיבל מכל המקורות הנ"ל גם
        לערבים.</li>
      <li>למען הסר ספק, הננו מסכימים לאמור לעיל, ומוותרים על זכויותינו לסודיות או לאחריות הבנק ביחס למידע המפורט לעיל,
        על פי כל הסכם, נוהג בנקאי ו/או דין לרבות חוק הגנת הפרטיות התשמ"א- 1980, ו/או כל חוק אחר, ובלבד שהשימוש במידע
        ושמירתו יעשו בכפוף ובהתאם להוראות חקיקה ואסדרה, כפי שיהיו בתוקף מעת לעת.</li>
      <li>הסכמתנו שלעיל ניתנת בכפוף לכך שנהייה זכאים להודיע לכם בכל עת על ביטולה. אולם ידוע לנו , כי לא נהיה זכאים לבטל
        הסכמתנו זו בטרם פרענו את כל האשראי שלנו אצלכם.</li>
      <li>אנו מסכימים לשמירת המידע ע"י הבנק.</li>
    </ol>
  </div>
  <!--CB-->
  <div class="row">
    <div class="col-12 mt-2">
      <input [formControl]="agreeEmail" type="checkbox" class="app-input" name="checkbox-2" id="checkbox-2b"
        [checked]="true" tabindex="0">
      <label for="checkbox-2b" class="check" tabindex="0" data-id="check-agree-mail">
        {{'TERMS_OF_USE.CBOX_MARKETING'|translate}}
      </label>
      <app-messages *ngIf="isDisplayed" [msgArr]="errorMessageOnComponent"></app-messages>
    </div>
  </div>
  <div class="text-center">
    <button class="responsive-button  app-button button-primary-disabled m-terms-use-btn px-3 mt-2" (click)="continue()"
      tabindex="0">{{'TERMS_OF_USE.AGREE' | translate}}</button>
  </div>


// WEBPACK FOOTER //
// ./src/app/terms-of-use/terms-of-use.component.html